import {useState} from 'react';

/**
 * The confirmation open inside a list row, `null` when none is. A confirmed change runs once at a
 * time and closes the confirmation when it went through.
 */
export function useShareRowStep<Step extends string>() {
  const [step, setStep] = useState<Step | null>(null);
  const [isBusy, setIsBusy] = useState(false);

  const settle = async (action: () => Promise<boolean>) => {
    if (isBusy) return;
    setIsBusy(true);
    try {
      if (await action()) setStep(null);
    } finally {
      setIsBusy(false);
    }
  };

  return {step, setStep, isBusy, settle};
}
